module.exports = __webpack_public_path__ + "static/img/pando_logo_2021-9-27.6481ca94.png";